module.exports = __webpack_public_path__ + "static/p10-0c4f1890a8c67d4508fc5df05751cd2e.jpg";